import React, { useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    Box,
    IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { updateContract } from "state/apis";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";

const AddDocuments = ({ open, onClose, onSubmit, details }) => {
    const theme = useTheme();
    const [data, setData] = useState({
        propertyId: details?.propertyId || "",
        unitId: details?.unitId || "",
        tenantId: details?.tenantId || "",
        yearRent: details?.yearRent || "",
        // totalYearsOfStay: details?.totalYearsOfStay || "",
        contractFrom: details?.contractFrom || "",
        contractTo: details?.contractTo || "",
        remarks: details?.remarks || "",
        deposit: details?.deposit || "",
        docs: [],
        closed: details?.closed || false,
    });

    const handleAddDocument = () => {
        setData((prevData) => ({
            ...prevData,
            docs: [...prevData.docs, { name: "", file: null }],
        }));
    };

    const handleDocumentNameChange = (index, value) => {
        const updatedDocuments = [...data.docs];
        updatedDocuments[index].name = value;
        setData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };
    const handleCancelDocument = (indexToRemove) => {
        setData((prevState) => ({
            ...prevState,
            docs: prevState.docs.filter((_, index) => index !== indexToRemove),
        }));
    };
    const handleDocumentFileChange = (index, file) => {
        const updatedDocuments = [...data.docs];
        updatedDocuments[index].file = file;
        setData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };

    const handleSubmit = async () => {
        try {
            const response = await updateContract(details?.id, data);
            toast.success(response.message);
            onSubmit();
            onClose();
            setData((prevData) => ({
                propertyId: "",
                unitId: "",
                tenantId: "",
                yearRent: "",
                // totalYearsOfStay: "",
                contractFrom: "",
                contractTo: "",
                remarks: "",
                deposit: "",
                docs: [],
                closed: false,
            }));
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                        marginLeft: "6px",
                    }}
                >
                    Add documents
                    <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3} p={"5px"}>
                        <Grid
                            item
                            xs={12}
                            m={3}
                            mb={1}
                            border={1}
                            borderRadius={1}
                            p={2}
                            mr={0}
                            sx={{ borderColor: "grey.400" }}
                        >
                            <Grid container alignItems="center" fullWidth>
                                <Grid item xs={10}>
                                    <label style={{ color: theme.palette.grey[600] }}>
                                        Contract Documents
                                    </label>
                                </Grid>
                                <Grid item xs={2} container justifyContent="flex-end">
                                    <Button variant="contained" onClick={handleAddDocument}>
                                        Add Document
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                {data?.docs.map((document, index) => (
                                    <Grid container spacing={2} key={index} p={1}>
                                        <Grid item xs={5}>
                                            <TextField
                                                fullWidth
                                                color="primary"
                                                label="Document Name"
                                                value={document.name}
                                                onChange={(e) =>
                                                    handleDocumentNameChange(index, e.target.value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={4} margin={"auto"}>
                                            <input
                                                type="file"
                                                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                onChange={(e) =>
                                                    handleDocumentFileChange(
                                                        index,
                                                        e.target.files[0]
                                                    )
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={3} container justify="end" margin="auto">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleCancelDocument(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>

                    <DialogActions>
                        <Grid container spacing={2} alignItems="center">
                            {/* {editMode && (
                                <Grid item xs={12} sm="auto">
                                    <Button
                                        variant="contained"
                                        onClick={handleOpenReceipt}
                                        sx={{
                                            color: theme.palette.primary.light,
                                            backgroundColor: "green",
                                        }}
                                    >
                                        Add Receipts
                                    </Button>
                                </Grid>
                            )} */}
                            <Grid item xs={12} sm="auto" sx={{ ml: "auto" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        justifyContent: { xs: "center", sm: "flex-end" },
                                    }}
                                >
                                    {/* <Button
                                        variant="contained"
                                        onClick={onClose}
                                        sx={{
                                            color: theme.palette.primary,
                                            backgroundColor: theme.palette.primary[800],
                                        }}
                                    >
                                        Cancel
                                    </Button> */}
                                    <Button
                                        variant="contained"
                                        onClick={handleSubmit}
                                        sx={{
                                            color: theme.palette.primary.light,
                                            backgroundColor: theme.palette.secondary[200],
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default AddDocuments;
